/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroups,
    GetProductCategoties,
    GetFactoriesByGroupID,
    GetProductsByFactoryIDProductcatogeryID,

    GetOrderReallocationBreakdownReport,
    GetVCCFactoriesByGroupID
};

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}


async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

//For only VCC type factories
async function GetVCCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetVCCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetProductsByFactoryIDProductcatogeryID(factoryID, productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductcatogeryID', 'factoryID=' + factoryID + '&productcatogeryID=' + productcatogeryID);
    return response.data;
}

async function GetOrderReallocationBreakdownReport(model) {
    const response = await CommonPost('/api/ReallocationBreakdownReport/GetOrderReallocationBreakdownReport', null, model);
    return response.data;
}
